<!--  -->
<template>
<transition name="bounce">
  <div class="message" v-if="isShow">
    <span>{{info }}</span>
  </div>
</transition>
  
</template>

<script>
export default {
  data () {
    return {
        info: '',
        isShow: false
    };
  },

  components: {},

  computed: {},

  mounted() {},

  methods: {
      showMessage(option) {
          option = option || {}
          this.info = option.info
          this.isShow =  true
          setTimeout(() => {
            this.hideMessage()
          }, 1000);
      },

      hideMessage() {
          this.isShow = false
      }
  }
}

</script>
<style lang='less' scoped>
.message {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  width:476px;
  height:50px;
  text-align: center;
  color:rgba(9,2,3,1);
  background:rgba(252,241,213,1);
  border:1px solid rgba(190,190,190,1);
  border-radius: 25px;
  box-shadow:0px 0px 12px 0px rgba(55,55,55,0.29);
  z-index: 2999;
}
.bounce-enter-active {
  animation: bounce-in .5s;
}
.bounce-leave-active {
  animation: bounce-in .5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
</style>